import Link from "next/link";
import { useState } from "react";
import ReportIssueModal from "../ReportIssueModal";

const SingleFooter = ({ classOne, title, footerType }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className={classOne}>
        <div className="footer-widget">
          <h5 className="ft-title">{title}</h5>
          <ul className="ft-link">
            {footerType.map((value, innerIndex) => (
              <li key={innerIndex}>
                <Link href={value.link || "#"}>
                  {value.icon && <i className={`${value.icon}`} style={{ marginRight: "8px", fontSize: "16px", verticalAlign: "middle" }}></i>}
                  <span>{value.text}</span>
                </Link>
              </li>
            ))}
            {title == "Help Center" && (
              <li>
                <Link
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowModal(true);
                  }}
                  style={{
                    color: "#3b82f6",
                    fontWeight: 600,
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  🐞 Report an Issue
                </Link>
              </li>
            )}

          </ul>
        </div>
      </div>
      <ReportIssueModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={(data) => console.log("Reported:", data)}
      />
    </>
  );
};

export default SingleFooter;
